import { useMutation, useQuery } from "@tanstack/react-query";
import { backendClient, httpClientForIframe } from "../httpClient";

export const useGetProductDataById = (id) => {
  const { data, error, isLoading } = useQuery({
    queryKey: ["url_id", id],
    queryFn: () =>
      httpClientForIframe.get(`/get_showcase`, {
        params: { url_id: id },
      }),
    refetchOnWindowFocus: false,
  });
  return { data, error, isLoading };
};

export const useSetActionCall = () => {
  const { mutate, isLoading, data, error } = useMutation({
    mutationFn: async (payload) => {
      const response = await backendClient.post(
        "/player/send_socket_message",
        payload
      );
      return response.data;
    },
  });

  return { mutate, isLoading, data, error };
};
